import React, { useState, useEffect } from 'react';
import { FilterSearch, FilterState, FilterDate, FilterPicker } from '../../components/Filter/FilterHooks';
import { AlertContainer } from '../../container/Works/AlertContainer';
import { Button } from 'reactstrap';
import moment from 'moment';
import { InputXml } from '../../components/InputXml/InputXml';
import { ScheduleConfirmModal } from './ScheduleConfirmModal';
import { NextAlerts } from './NextAlerts';
import ScheduleList, { StatusEnumName, StatusEnum } from '../Schedule/ScheduleList';
import { toDateFormat } from './InspectionView';
import GetAppIcon from '@material-ui/icons/GetApp';
import FileSaver from 'file-saver';
import { DateRange, SelectInput } from '../../layoutV2/components/Form';
import { FiDownload } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux';
import { setLoginData } from '../../core/redux-store/login/Actions';

let defaultFilterValues = {
    name: "",
    state: [],
    /* startDate: [],
    endDate: [], */
    alert: false,
    dates: {},
};

/* const toDateFormat = (date, format = 'DD/MM/YYYY') => {
    if (!date) {
        return;
    }

    const formattedDate = date.seconds ? new Date(date.seconds * 1000) : new Date(date);
    return moment(formattedDate).format(format ? format : 'DD/MM/YYYY');
} */

const toDate = (date) => {
    if (!date) {
        return;
    }

    return date.seconds ? new Date(date.seconds * 1000) : new Date(date);
}

const compareDate = (a, b) => {
    const dateA = toDate(a.startDate);
    const dateB = toDate(b.startDate);

    if (!dateA || !dateB) {
        return 0;
    }

    return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
}

const getFilteredData = (data, filterValues) => {
    return data.filter(item => doFilter(item, filterValues))
}

const doFilter = (rowData, filterValues) => {
    let hasState = true;
    if (filterValues && filterValues.state && filterValues.state.length > 0) {
        hasState = filterValues.state.findIndex(state => (state && state.value && rowData.status) && StatusEnum[(state.value).toLowerCase()] === rowData.status) > -1
    }

    let hasSearch = true;
    if (filterValues && filterValues.name) {
        hasSearch = rowData.Name.toLowerCase().includes(filterValues.name.toLowerCase());
    }

    let hasAlert = true;
    if (filterValues && filterValues.alert) {
        hasAlert = rowData.alert;
    }

    let hasDates = true;
    if (filterValues && filterValues.dates && filterValues.dates.startDate && filterValues.dates.endDate) {
        const criteriaDates = () => moment(rowData.Start, "YYYY-MM-DD").diff(moment(filterValues.dates.startDate, "DD-MM-YYYY"), 'days') >= 0 &&
            moment(rowData.Finish, "YYYY-MM-DD").diff(moment(filterValues.dates.endDate, "DD-MM-YYYY"), 'days') <= 0

        const criteriaEnd = () => moment(rowData.Finish, "YYYY-MM-DD").diff(moment(filterValues.dates.startDate, "DD-MM-YYYY"), 'days') >= 0 &&
            moment(rowData.Finish, "YYYY-MM-DD").diff(moment(filterValues.dates.endDate, "DD-MM-YYYY"), 'days') <= 0

        const criteriaStart = () => moment(rowData.Start, "YYYY-MM-DD").diff(moment(filterValues.dates.startDate, "DD-MM-YYYY"), 'days') >= 0 &&
            moment(rowData.Start, "YYYY-MM-DD").diff(moment(filterValues.dates.endDate, "DD-MM-YYYY"), 'days') <= 0

        hasDates = criteriaEnd() || criteriaStart() || criteriaDates();
    }

    return hasSearch && hasState && hasAlert && hasDates;
}

let states = [
    {
        label: "Concluído",
        value: "Concluido"
    },
    {
        label: "Executando",
        value: "Executando"
    },
    {
        label: "Liberado",
        value: "Liberado"
    },
    {
        label: "Planejado",
        value: "Planejado"
    },
    {
        label: "Parado",
        value: "Parado"
    },
    {
        label: "Impedido",
        value: "Impedido"
    }
];

export const ScheduleView = (props) => {
    // const [filterValues, setFilterValues] = useState(defaultFilterValues);
    const dispatch = useDispatch()
    const [editRecord, setEditRecord] = useState();
    const filterList = useSelector(state => state.login["schedule-list"])

    useEffect(() => {
        if (filterList && filterList.dates) {
            const newFilter = { ...filterList, "dates": {} };
            dispatch(setLoginData({ ["schedule-list"]: newFilter }))
        }
    }, [])
    // const onFilter = (field, value) => {
    //     // console.log({ field, value })
    //     const values = { ...filterValues, [field]: value }
    //     setFilterValues(values);
    //     defaultFilterValues = values;
    // }

    const toggle = () => {
        setEditRecord();
        props.setReload(reload => !reload)
    }

    // useEffect(() => {
    //     setFilterValues({
    //         name: "",
    //         state: [],
    //         alert: false,
    //         dates: {},
    //     })
    // }, [props.location.state.workId])

    const exportPDF = async () => {
        const noSchedule = props.workData && props.workData.noSchedule
        // let url = "http://localhost:5000/app-ike/us-central1/api3/report-inspection"
        let url = "https://us-central1-app-ike.cloudfunctions.net/api3/report-inspection"

        const filteredList = await getFilteredData(props.data, filterList)
        const { company, work } = props && props.history && props.history.location && props.history.location.state

        if (filteredList.length > 0) {
            const list = filteredList.map(item => {
                return {
                    number: item.OutlineNumber,
                    ...item.UID,
                    start: noSchedule ? "" : moment(item.Start, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    end: noSchedule ? "" : moment(item.Finish, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    name: item.Name,
                    status: StatusEnumName[item.status] || ""
                }
            })

            fetch(url, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    list,
                    client: company.name,
                    respTec: work.responsible,
                    address: work.address,
                    regProf: work.regProf,
                    work: work.name,
                    logo: "data:image/jpeg;base64,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",
                    date: toDateFormat(new Date),
                })
            }).then(function (response) {
                return response.blob();
            }).then(function (blob) {
                FileSaver.saveAs(blob, 'inspeção.pdf');
            })
        }

    }

    return (
        <>
            <div className="content overflowVisible skills-screen skills">
                <ScheduleConfirmModal onConfirm={props.onConfirm} isOpenModal={props.isOpenModal} toggle={() => props.setIsOpenModal(!props.isOpenModal)} />
                <ScheduleList
                    {...props}
                    setEditRecord={setEditRecord}
                    filterValues={filterList}
                    getFilteredData={(data, filterValues) => getFilteredData(data, filterValues)}
                    leftComponent={(onFilter, filter) => <div className="buttons-schedule-left">
                        {/* {!props.user.groupData.isModel && props.workData && !props.workData.noSchedule && < DateRange
                            onDateChange={(field, values) => onFilter("dates", values)}
                            startDate={filter.dates && filter.dates.startDate}
                            endDate={filter.dates && filter.dates.endDate}
                        />} */}
                        {props.workData && !props.workData.noSchedule && <SelectInput onChange={(values) => onFilter("status", values)} value={filter.status} options={props.defaultState} labelledBy={"Filtrar por estado"} title={"Filtrar por estado"} />}
                        <NextAlerts location={props.location} reload={props.reload} setReload={props.setReload} />
                        <Button className="button-download-schedule" onClick={() => exportPDF()}>
                            <FiDownload size={25} />
                        </Button>
                        <InputXml onDataChanged={props.onDataChanged} noSchedule={props.workData && props.workData.noSchedule} />
                    </div>}
                    moreModalFields={(onFilter, filter) => {
                        return <div className="buttons-modal-schedule">
                            {/* <DateRange
                                onDateChange={(field, values) => onFilter("dates", values)}
                                startDate={filter.dates && filter.dates.startDate}
                                endDate={filter.dates && filter.dates.endDate}
                            /> */}
                            <SelectInput onChange={(values) => onFilter("status", values)} value={filter.status} options={props.defaultState} labelledBy={"Filtrar por estado"} title={"Filtrar por estado"} />
                        </div>
                    }}
                />
                <AlertContainer location={props.location} toggle={toggle} data={editRecord} defaultState={props.defaultState} isCompany={props.company} />
            </div>
            {/* <InputXml onDataChanged={props.onDataChanged} /> */}

        </>
    );
};


// <div className="filter-container">
//     <div className="actions" style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
//         {/* <FilterSearch onFilterSearch={onFilter} value={filterValues.search} /> */}
//         <div className="filter-lib">
//             <FilterPicker onFilter={(field, value) => onFilter("state", value)} value={filterValues.state} comboOptions={states} placeholder="Filtrar por estado" />
//         </div>
//         {/* <FilterState onFilter={onFilter} value={filterValues.state} comboOptions={props.defaultState} /> */}
//         <FilterDate style={{ maxWidth: 190 }} onDateChange={onFilter} startDate={filterValues.dates.startDate} endDate={filterValues.dates.endDate} />
//         <NextAlerts location={props.location} reload={props.reload} setReload={props.setReload} />
//         <Button className="button-schedule-screen" onClick={() => exportPDF()}>
//             <GetAppIcon style={{ top: -2, position: "relative" }} />
//         </Button>
//         <InputXml onDataChanged={props.onDataChanged} />
//     </div>
// </div>


/*
<Button size="sm" className={`${filterValues.alert ? "button-alert active" : "button-alert"}`} onClick={() => onFilter("alert", !filterValues.alert)} >
    <i class="material-icons">add_alert</i>
</Button>
*/